import { render, staticRenderFns } from "./PriceGrids.vue?vue&type=template&id=011964ce&scoped=true"
import script from "./PriceGrids.vue?vue&type=script&lang=js"
export * from "./PriceGrids.vue?vue&type=script&lang=js"
import style0 from "./PriceGrids.vue?vue&type=style&index=0&id=011964ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011964ce",
  null
  
)

export default component.exports